import React, { useEffect, useState } from "react";
import { Main } from "../style/dashboard";
import Navbar from "../components/navbar/driverNav";
import Button from "@mui/material/Button";
import { getTripList, postData } from "../services/driver";
import { connect } from "react-redux";
import { setData } from "../Redux/mainActions";
import WayCard from "../components/dashboard/onethewaycard copy";
import CustomBottomNavigation from '../components/footer';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Typography from "@mui/material/Typography";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AvTimerIcon from '@mui/icons-material/AvTimer';
function Waiting() {
  const [tripdata, setTdata] = useState([]);
  const getData = async (e) => {
    // try {
    const { data } = await getTripList();
    console.log(data.data.trips.data);
    setTdata(data.data.trips.data);
  };

  useEffect(() => {
    getData();
    setInterval(() => getData(), 100000);
  }, []);
  return (
    <Main>
      <Navbar Button="/driverDashboard" Detatil="داشبورد" />
      {tripdata.length ? (
        <>

          <p
            style={{
              fontFamily: "SansX",
              color: "black",
              alignSelf: "center",
              marginTop: "1vh",
              textAlign:"center"
            }}
          >
            سفرهای انجام شده توسط شما
          </p>
          <Container
              maxWidth="sm"
          >
            <Box
                width={1} height={200}
                my={4}
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={4}
                p={2}
            >
              <Box
                  width={1} height={150}
                  my={4}
                  display="flex"
                  alignItems="end"
                  justifyContent="space-between"
                  gap={4}
                  p={2}
                  pt={3}
                  sx={{ boxShadow: 4, background:'#ffffff'}}
              >

                <Box
                    sx={{
                      width: 150,
                      height: 81,
                      borderRadius: 1,
                      direction:'rtl',
                    }}
                >
                  <Box
                      display='flex'
                      justifyContent='start'
                  >
                    <AvTimerIcon

                        sx={{
                          color:'#b4d8ff',
                          'padding-right':'9px'
                        }}
                    ></AvTimerIcon>
                  </Box>
                  <Typography>کیلومتر <Typography sx={{
                    'margin-right' : '20px',
                    color:'#141513'
                  }}>475 </Typography></Typography>
                </Box>

                <Box
                    sx={{
                      width: 150,
                      height: 81,
                      borderRadius: 1,
                      direction:'rtl',
                    }}
                >
                  <Box
                      display='flex'
                      justifyContent='start'
                  >
                    <AccessTimeIcon

                        sx={{
                          color:'#b4d8ff',
                          'padding-right':'7px'
                        }}
                    ></AccessTimeIcon>
                  </Box>
                  <Typography>ساعت  <Typography sx={{
                    'margin-right' : '20px',
                    color:'#141513'
                  }}>11</Typography></Typography>
                </Box>
                <Box
                    sx={{
                      width: 150,
                      height: 81,
                      borderRadius: 1,
                      direction:'rtl',
                    }}
                >
                  <Box
                    display='flex'
                    justifyContent='start'
                  >
                    <DirectionsCarIcon

                    sx={{
                      color:'#b4d8ff',
                      'padding-right':'14px'
                    }}
                    ></DirectionsCarIcon>
                  </Box>
                  <Typography>تعداد سفر  <Typography sx={{
                    'margin-right' : '20px',
                    color:'#141513'
                  }}>41</Typography></Typography>
                </Box>

              </Box>
            </Box>
          </Container>
          {/* // <Card data={tripdata} /> */}
          {tripdata.map((e) => (
            <WayCard data={e} getData={getData} />
          ))}
        </>
      ) : (
        <>
          <p
            style={{
              fontFamily: "SansX",
              color: "gray",
              alignSelf: "center",
              marginTop: "30vh",
            }}
          >
            ...در حال بارگزاری , لطفا منتظر بمانید
          </p>
        </>
      )}

      <CustomBottomNavigation route2='/historyDriver' label='در نزدیکی شما' route='/waitingdriver' />
    </Main>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setData: (value) => dispatch(setData(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Waiting);
